<template>
  <div class="critical-error-page">
    <div class="content">
      <h1 class="title">{{$tI('Iframe error message title')}}</h1>
      <p class="message">
        Our system is currently experiencing issues with this service. Please try again later.
        {{$tI_G('Iframe error message subtitle')}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CriticalErrorPage',
  created() {
  },
};
</script>

<style scoped>
.critical-error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8d7da17;
  color: #721c24;
  text-align: center;
  font-family: Arial, sans-serif;
}

.content {
  padding: 20px;
  border: 1px solid #f5c6cb;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.title {
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 10px;
}

.message {
  font-size: 18px;
  margin-bottom: 20px;
}

.contact a {
  color: #721c24;
  text-decoration: underline;
}

.contact a:hover {
  text-decoration: none;
}
</style>
